export default "__VITE_ASSET__B_8hMi0s__"